export default {
  Form_Common: {
    ZhuShuShi: '主诉及现病史',
    MaiZhen: '脉诊',
    SheZhen: '舌诊',
    BingMing: '病名',
    ZhengXing: '证型',
    ZhiZeZhiFa: '治则治法',
    YaoPingZhiXingBiaoZhun: '药品执行标准',
    BaoCi: '包/次',
    KeBao: '克/包',
    MiaoShu: '描述',
    YinPian_FenLiang: '饮片分量',
    RiQi: '日期',
    ZhangHao: '账号',
    MiMa: '密码',
    QingShuRu: '请输入',
    QingXuanZe: '请选择',
    XingMing: '姓名',
    NieCheng: '昵称',
    ZhiGong_LeiBie: '职工类别',
    YiShi: '医师',
    ShouQuan_YiShi: '授权医师',
    HuShi: '护士',
    HuShi_Shi: '护师',
    YaoJiShi: '药剂师',
    QiTa: '其他',
    ZhengJian_LeiXing: '证件类型',
    JuMin_ShenFenZheng: '居民身份证',
    JuMin_HuKouBu: '居民户口簿',
    HuZhao: '护照',
    JunGuan_Zheng: '军官证',
    JiaShi_Zheng: '驾驶证',
    GangAo_TongXingZheng: '港澳居民来往内地通行证',
    TaiWan_TongXingZheng: '台湾居民来往内地通行证',
    ChuSheng_YiXue_ZhengMing: '出生医学证明',
    ZhengJian_HaoMa: '证件号码',
    ZhongWen_XingMing: '中文姓名',
    YingWen_XingMing: '英文姓名',
    DiQu: '地区',
    DiZhi: '地址',
    XiangXi_DiZhi: '详细地址',
    ZhaoPian: '照片',
    MiaoShu_Text: '描述',
    ZhengShu: '证书',
    ZhengShu_BianHao: '证书编号',
    YiJianTong_ID: '医健通ID',
    ZhengShu_MingCheng: '证书名称',
    FaZheng_ShiJian: '发证时间',
    YouXiao_Qi: '有效期',
    FuJian: '附件',
    PaiBan: '排班',
    Bu_PaiBan: '不排班',
    JueSe_Ming: '角色名',
    JueSe_MiaoShu: '角色描述',
    QuanXian_FanWei: '权限范围',
    ShuJu_QuanXian: '数据权限',
    Jin_BenRen: '仅本人',
    YuanGong_SuoZai_ZhenSuo: '员工所在的诊所',
    BuFen_ZhenSuo: '部分诊所',
    QuanBu_ZhenSuo: '全部诊所',
    ShiYong_ZhenSuo: '适用诊所',
    BingLi_MianShouQuan_ChaKan_TaRen_JiLu: '可查看他人录入的病历（免授权）',
    GuaHao_JinXianShi_BenRen_HaoYuan: '仅显示本人名下号源（挂号）',
    GuaHao_XianShi_QuanBu_HaoYuan: '显示全部号源（挂号）',
    JinXianShi_BenRen_JingShou_JiLu: '仅显示本人经手的记录（预约、诊症、收费、理疗、配药）',
    JinXianShi_QuanBu_JiLu: '显示全部记录（预约、诊症、收费、理疗、配药）',
    QuanXuan: '全选',
    ShiFou_PeiSong: '是否配送',
    YouFei: '邮费',
    Xian_JiuZhen_Hou_FuKuan: '先就诊后付款',
    ZhiFu_FangShi: '支付方式',
    XianShang_ZhiFu: '线上支付',
    XianXia_ZhiFu: '线下支付',
    YiBao: '医保',
    Bao: '包',
    Ci: '次',
    Ke: '克',
    YaoPin_ZhongLiang: '药品重量',
    WuCha: '误差',
    AnZhao_BiLi_JiSuan: '按照比例计算',
    KaiShi_Zhi: '开始值',
    JieShu_Zhi: '结束值',
    ShiFou_YongHu_Quan: '用户券',
    ShiFou_GuoQi: '是否过期',
    GuoQi_LeiXing: '过期类型',
    HuaDong_GuoQi: '滑动过期',
    GuDing_RiQi_GuoQi: '固定日期过期',
    GuoQi_ShiChang: '过期时长',
    GouMaiRenYuan_BiaoZhu: '（购买人员）',
    Tian: '天',
    Yue: '月',
    Nian: '年',
    SanTian: '三天',
    YiZhou: '一周',
    BanGeYue: '半个月',
    YiGeYue: '一个月',
    SanGeYue: '三个月',
    BanNian: '半年',
    YiNian: '一年',
    LiangNian: '两年',
    SanNian: '三年',
    WuNian: '五年',
    ShiFou_ZaiShou: '是否在售',
    ShouMai_KaiShi: '售卖开始',
    ShouMai_JieShu: '售卖结束',
    LeiBie: '类别',
    ZheKou_Quan: '折扣券',
    ManJian: '满减',
    DaiJin_Quan: '代金券',
    YouHuiQuan: '优惠券',
    YiLiao_Quan: '医疗券',
    TaoPiao: '套票',
    Zi_Medicine: '药',
    Zi_Acupuncture: '针',
    Zi_Img: '影',
    Zi_Postage: '邮',
    Zi_Fee: '诊',
    Zi_Massage: '推',
    Zi_Cupping: '拔',
    QiYong: '启用',
    TingYong: '停用',
    Zhe: '折',
    YouHuiQuan_LeiXing: '优惠券类型',
    ShiLi: '示例',
    ZheKou: '折扣',
    ShiYong_FanWei: '使用范围',
    ChuFang_Dan: '处方单',
    ZhenJiu_Dan: '针灸单',
    WenDang_YingXiang_Dan: '文档影像单',
    LingShou: '零售',
    OTC: 'OTC',
    KuaiDi_Dan: '快递单',
    TuiNa_ZhengGu: '推拿/正骨',
    BaGuan: '拔罐',
    ShengShi_Qu: '省市区',
    JieShao_TuJing: '介绍途径',
    PengYou: '朋友',
    ChuanDan: '传单',
    BaoZhi_ZaZhi: '报章杂志',
    HuLianWang: '互联网',
    DianYou: '电邮',
    ChuFang_GongKai: '处方公开',
    ShiYong_YiLiao_Quan: '使用医疗券',
    YaoPin_JiSuan_GuiGe: '药品计算规格',
    CaoYao: '草药',
    NongSuo_Yao: '浓缩药',
    YinPian: '饮片',
    YaoPin_ZhiXing_BiaoZhun: '药品执行标准',
    DiZhi_XinXi: '地址信息',
    ShouHuoRen_XingMing: '收货人姓名',
    ZhiFu_QuDao: '支付渠道',
    YiLiao_Quan_Item: '医疗券',
    MeiTuan: '美团',
    ChuZhi_Ka: '储值卡',
    YaoPin_MingCheng: '药品名称',
    YaoPin_BianMa: '药品编码',
    PinPai: '品牌',
    You_Wu_KuCun: '有无库存',
    You_KuCun: '有库存',
    Wu_KuCun: '无库存',
    ShiFou_QiYong: '是否启用',
    ZuiXiao_YuJing_Liang: '最小预警量',
    ZuiDa_YuJing_Liang: '最大预警量',
    DingDan_BianHao: '订单编号',
    DingDan_ShiJian: '订单时间',
    ZhuangTai: '状态',
    ZhongDuan: '终端',
    DongZuo: '动作',
    BeiZhu: '备注',
    ShenHe_JieGuo: '审核结果',
    TongGuo: '通过',
    Bu_TongGuo: '不通过',
    ShenPi_YiJian: '审批意见',
    QianShou_Ren: '签收人',
    QuanBu_YaoPin: '全部药品',
    DiaoZheng_ShiJian: '调整时间',
    DianZi_QianMing: '电子签名',
    MingCheng: '名称',
    YaoWu_JiFei: '药物计费',
    ZhenJiu_FeiYong: '针灸费用',
    LingShou_JiFei: '零售计费',
    ChongZhi: '充值',
    TaoPiao_JiFei: '套票计费',
    TuiNa_FeiYong: '推拿费用',
    BaGuan_FeiYong: '拔罐费用',
    ZhongLei: '种类',
    JiChu: '基础',
    ChengBen: '成本',
    JiFei: '计费',
    TianShu: '天数',
    ShouJia: '售价',
    YongLiang: '用量',
    TuXiang: '图像',
    Zi_Product: '售',
    Zi_Ticket: '票',
    ShouFei_LeiBie: '收费类别',
    JiFei_ZhongLei: '计费种类',
    JiFei_FangFa: '计费方法',
    NongSuo_Yao_SheDing: '浓缩药设定',
    MoRen: '默认',
    YinPian_SheDing: '饮片设定',
    JiBen_ShouFei: '基本收费',
    MeiTian_ShouFei: '每天收费',
    NongSuo_Yao_MeiTian_ShouFei: '浓缩药每天收费',
    YinPian_MeiTian_ShouFei: '饮片每天收费',
    ShouFei_XiangMu: '收费项目',
    YuShe_ShouFei: '预设收费',
    YingWen_MingCheng: '名称英文',
    NianLing: '年龄',
    ZuBie: '组别',
    Bu_XianShi: '不显示',
    ChuFang_NianLing_XianShi: '处方年龄显示',
    KaiShi_Zhi_Short: '开始值',
    JieShu_Zhi_Short: '结束值',
    Sui: '岁',
    Ke_BianJi: '可编辑',
    JiBie: '级别',
    YouHui: '优惠',
    QiBu_JinE: '起步金额',
    KaPian_MingCheng: '名称',
    YuYue_RiQi: '预约日期',
    JinE: '金额',
    HuoDong_MingCheng: '活动名称',
    KaiShi_ShiJian: '开始时间',
    JieShu_ShiJian: '结束时间',
    ZuMing_Cheng: '名称',
    XiangQing: '详情',
    ChaoShou: '超收',
    MianShou_XianDing_ChengBen_JinE: '免收限定成本金额',
    JiaShou_JinE: '加收金额',
    YiShi_LeiXing: '医师类型',
    ZhuCe_YiShi: '注册医师',
    BiaoLie_YiShi: '表列医师',
    ChuZhiKa_ChongZhi: '储值卡充值',
    KeHu_JieShou_TuiGuang: '客人接受推广',
    DuiZhang_ShiJian: '对账时间',
    DingDan_Shu: '订单数',
    ShangPin_ZhuangTai: '商品状态',
    ShangPin_MingCheng: '商品名称',
    QiTa_LianXi_FangShi: '其他联系方式',
    An_Ri: '按日',
    An_Yue: '按月',
    DingDan_LaiYuan: '来源',
    ShouKuan: '收款',
    TuiKuan: '退款',
    Wei_ZhiFu: '未支付',
    Dai_TiHuo: '待提货',
    Yi_WanCheng: '已完成',
    TuiDan: '退单',
    ZuoFei: '作废',
    YiShi_XingMing: '医师姓名',
    ShiFou_PaiBan: '是否排班',
    YaoPin_DaBao: '药品打包',
    An_XiaoLv: '按效率',
    An_JingDu: '按精度',
    XiangMu_JiaGe: '项目价格',
    XiangMu_MiaoShu: '项目描述',
    XiangMu_ShiJian: '项目时间',
    GuanLian_XiangMu: '关联项目',
    TaoPiao_MingCheng: '套票名称',
    ShiFou_GuoQi_Short: '是否过期',
    GuoQi: '过期',
    Wei_GuoQi: '未过期',
    PaiXu_XuHao: '排序序号',
    ZhenZheng_Xu_Shu_Ru_ZiLiao: '诊症需输入资料',
    SuoYou_LanWei: '所有栏位',
    DanWei: '药品单位',
    ShuRu_DanWei: '输入单位',
    ChuFang_DanWei: '处方单位',
    YaoPin_PaiXu: '药品排序',
    ShuRu: '输入',
    DaYin_LeiXing: '打印类型',
    Mei_Jie_ShiJian: '每节时间',
    ShengCheng_HaoYuan_TianShu: '生成号源天数',
    GuiZe_MingCheng: '规则名称',
    YouXiao_RiQi: '有效日期',
    QuanBu: '全部',
    YingYe_ShiJian: '营业时间',
    XingQi: '星期',
    HaoYuan: '号源',
    PaiBan_Rules: '排班',
    ShuoMing: '说明',
    ShuoMing_En: '说明(En)',
    BingRen_XingMing: '病人姓名',
    Ming_En: '名(En)',
    Xing_En: '姓(En)',
    ZhenSuo_ZhuanTai: '诊所状态',
    ZhenSuo_BianMa: '诊所编码',
    ZhenSuo: '诊所',
    KaiMen_ShiJian: '开门时间',
    GuanMen_ShiJian: '关门时间',
    ZhenSuo_MinCheng: '诊所名称',
    YingWen_MinCheng: '英文名称',
    YingWen_DiZhi: '英文地址',
    JingWeiDu: '经纬度',
    ZhenSuo_Logo: '诊所Logo',
    ZhenSuo_ZhaoPian: '诊所照片',
    YouWu_Biaozhun: '有无标准',
    YaoPin_YingWen_MingCheng: '药品英文名称',
    ShiFou_FuFangYao: '是否复方药',
    PinYin_ShouZiMu: '拼音首字母',
    GongNeng: '功能',
    GuiGe_YingWen: '英文规格',
    ChengFen_JiSuanLiang: '成分计算量',
    ZhuCe_BianMa: '注册编码',
    RuKu_DanWei: '入库单位',
    RuKu_DanWeiLiang: '入库单位量',
    AnQuanLiang: '安全量',
    MoRen_DanJia: '默认单价',
    MoRen_ChengBenjia: '默认成本价',
    JiWangShi: '既往史',
    ZiDian_LeiXing: '字典类型',
    YingWen_Ming: '英文名',
    YingWen_Xing: '英文姓',
    BuXian: '不限',
    HaoYuan_Shu: '号源数',
    ShiDuan: '时段',
    DangQian: '当前',
    QueRen_MiMa: '确认密码',
    Xin_MiMa: '新密码',
    QueRen_Xin_MiMa: '确认新密码',
    Yuan_MiMa: '原密码',
    Xin_ZhangHao: '新账号',
    Xin_NieCheng: '新暱称',
    YingYe_DiDian: '营业地点',
    PanDian_ShiJian: '盘点时间',
    TiaoZheng_ShiJian: '调整时间',
    TiaoZheng_YuanYin: '调整原因',
    MingGui_FuJia: '*名贵药材附加收费',
    FuJia_LeiXing: '附加类型',
    An_ZhongLiang: '按重量',
    An_TianShu: '按天数',
    Mian_FuJiaFei_EDu: '免附加费额度',
    MingGui_YaoCai: '名贵药材',
    ZhiFu: '支付',
    ZhiKu: '字库',
    ZhengZhuang: '症状',
    BiaoJi: '标记',
    ZuoYon: '作用',
    ZhongZheng: '重症',
    ShangPin_GuiGe_MingCheng: '药品规格名称',
    XiaoShou_DanWei: '销售单位',
    XiaoShou_RenYuan: '销售人员',
    KunBan_YouHui: '捆绑优惠',
    DanPin_YouHui: '单品优惠',
    ChengPinYao: '成品药',
    YuYue: '预约',
    Yi_TuiKuan: '已退款',
    BuFen_ZhiFu: '部分支付',
    KuCun_GaoJing: '库存告警',
    LiLiao_YiShi: '理疗医师',
    JinJi_LeiXing: '禁忌类型',
    JinJi_MoBan: '禁忌模板',
    BieMing: '别名',
    ZuZhi: '组织',
    ZuZhi_BianMa: '组织编码',
    ZuZhi_MinCheng: '组织名称',
    MiYao: '秘钥',
    MiYao_MinCheng: '秘钥名称',
    YuMing: '域名',
    ChengYuan_ShangXian: '成员上限',
    JinZhi_XinZeng: '禁止新增',
    BianDong_LaiYuan: '变动来源',
    BianDong_ShiJian: '变动时间',
    JianChaDan_DaLeiXing: '检查单大类型',
    ZhiBiao_BianMa: '指标编码',
    ZhiBiao_MingCheng: '指标名称',
    YingWen_SuoXie: '英文缩写',
    CanKao_FanWei: '参考范围',
    CanKao_FanWei_XiaXian: '参考范围下限',
    CanKao_FanWei_ShangXian: '参考范围上限',
    LinChuang_ShuoMing: '临床说明',
    XinZeng_JinJi_MoBan: '新增禁忌模板',
    XiuGai_JinJi_MoBan: '修改禁忌模板',
    Zhu_HuanZhe: '主患者',
    Dai_HeBing_HuanZhe: '待合并患者',
    KuaiJie_TuiJian: '快捷推荐：',
  },
}
